---
fr:
  general:
    24h_stats: 24h stats
    5min_stats: 5min stats
    7d_stats: 7jours stats
    access_level:
      admin: Administrateur
      developer: Développeur
      editor: Éditeur
      landowner: Propriétaire foncier
      portfolio: Portefeuille
    access_rights: Droits d'accès
    action_might_be_irreversible: Cette action pourrait être irréversible.
    activate: Activer
    active: Actif
    activity: Activité
    actual: Actuel
    add: Ajouter
    add_as_custom_chart: Ajouter en tant que graphique personnalisé?
    add_attachment: Ajouter une pièce jointe
    add_image: Ajouter une image
    add_new: Nouveau
    add_power-plant-supplier_connection: Ajouter une connexion fournisseur de centrale électrique
    add_supplier_role: Ajouter un rôle de fournisseur
    add_user: Ajouter un utilisateur
    admin: Admin
    all: Tous
    all_caps: ALL
    and: et
    apply: Appliquer
    are_you_sure: Êtes-vous sûr?
    area: Zone
    area_price: Zone de prix
    asset_class: Classe d'actifs
    avail_analysis: Analyse de disponibilité
    availability_calculation: Calcul de disponibilité
    average_last_24_hours: moy. 24h
    avg_price: Prix moyen
    back: Retour
    back_to_list: Retour à la liste
    basic: Basique
    basic_details: Détails de base
    bilateral: Bilatéral
    budget: Budget
    budget_lowercase: budget
    budgets: Budgets
    bulk_edit_hint: Collez les chiffres directement depuis Excel; utilisez des valeurs séparées par des tabulations pour le volume puis les revenus.
    bulk_update: Mise à jour en masse
    cancel: Annuler
    cant_delete_company: Impossible de supprimer l'entreprise
    capacity: Capacité
    card_description: Description de la carte
    category: Catégorie
    chart_title: Titre du graphique
    click_to_load_more: Cliquez pour en savoir plus
    climate_futures_inflow: Climate Futures afflux
    close: Fermer
    commercial_details: Détails commerciaux
    community: Communauté
    companies: Entreprises
    company: Entreprise
    company_access: Accès entreprise
    confirm: Confirmer
    confirmed: Confirmé
    connections: Connexions
    contact_kaiasolutions: Sélectionnez un portefeuille individuel avec accès correspondant, ou contactez le personnel du portail si vous souhaitez activer cette fonctionnalité.
    contract_deleted: Contrat supprimé
    contract_details: Détails du contrat
    contract_type: Type de contrat
    contracts_admin: Contrats Admin
    copied: Copié !
    copy: Copier
    country: Pays
    county: Région
    create: Créer
    created: Créé
    custom_lower_limit: Limite inférieure personnalisée
    custom_unit: Unité personnalisée
    custom_upper_limit: Limite supérieure personnalisée
    daily: Quotidien
    data_source: Source de données
    data_source_configuration: Configuration de la source de données
    date: Date
    date_from: Date de
    date_scope: Date
    date_to: Date à
    days: jours
    de: Allemand
    deactivate: Désactiver
    delete: Supprimer
    delete_all: Supprimer tout
    delete_failed: Échec de la suppression
    deleted: Supprimé
    description: Description
    details: Détails
    deviation: Déviation
    download: Télécharger
    edit: Éditer
    edit_supplier_role: Éditer le rôle du fournisseur
    edit_user: Éditer l'utilisateur
    elcert: Elcert
    elcert/GoO: Elcert / GoO
    elcert_full: Certificats Elcert
    email: Email
    en: Anglais
    end_date: Date de fin
    energy: Énergie
    error: Une erreur s'est produite. Veuillez réessayer.
    error_reset_password: Erreur de réinitialisation du mot de passe
    est_resource: Ressources est.
    event: Événement
    export_access: Accès à l'exportation
    feature_configuration: Configuration des fonctionnalités
    filter: filtre
    filter_by_company: Filtrer par entreprise
    filter_data: Filtrer les données
    first_name: Prénom
    flip_sign: Inverser le signe
    forecast: Prévision
    forecast_lowercase: prévision
    fr: Français
    general: Général
    go_expiry_date: Date d'expiration du GO
    go_full: Guaranties d'origine
    gwh: GWh
    half_yearly: Semestriel
    hide: Masquer
    hourly: Horaire
    hours: Heures
    hydro: Hydro
    image: Image
    inactive: Inactif
    inflow: Afflux
    intake: Admission
    ip: IP
    language: Langue
    last_activity: Dernière activité
    last_name: Nom de famille
    limit: Limite
    links: Liens
    lock_account: Verrouiller compte
    logged_in_successfully: Connecté avec succès
    login: Connexion
    login_failed: Échec de connexion
    login_failures: Échecs de connexion
    logo: Logo
    metering_point: Point de mesure
    month: Mois
    monthly: Mensuel
    mw: MW
    name: Nom
    nb: Norvégien
    new: new
    'no': non
    no_image_available: Aucune image disponible
    none: Aucun
    not_enabled: n'est pas activée pour le portefeuille sélectionné ou tous les portefeuilles dans la sélection globale.
    not_specified: Non spécifié
    now: actuel
    number_of_power_plants: nombre de centrales électriques
    nve_metadata: Métadonnées NVE
    ny_budget: Budget NY
    offset: Décalage
    operational_state: Status opérationnel
    or: ou
    org_no: Org. no
    other_info: Autres informations
    overview: Vue d'ensemble
    pareto: Pareto
    password: Mot de passe
    path: Chemin
    power_plant: Centrale
    power_plant_lowercase: centrale
    power_plant_names: Noms des centrales électriques
    power_plants: Centrales
    power_plants_lowercase: centrales
    power_prices: Prix de l'énergie
    power_production: Production d'énergie
    power_sales: Vente d'électricité
    precipitation: Précipitation
    price: Prix
    price_area: Zone de prix
    production: Production
    production_budget: Budget de la production
    production_forecast: Production prévue
    profile: Profile
    profile_lowercase: profile
    project: Projet
    quarterly: Trimestriel
    radiation: Ensoleillement
    remove: Supprimer
    remove_attachment: Supprimer l'annexe
    remove_image: Supprimer l'image
    report_generated: Rapport généré
    requests: Requêtes
    reset: Réinitialiser
    reset_password: Réinitialiser le mot de passe
    resolution: Résolution
    result: Résultat
    result_lowercase: résultat
    retry: Réessayer
    revenue: Revenu
    revenue_budget: Budget des revenus
    rotate: Régénérer
    runoff: Écoulement
    save: Enregistrer
    save_successful: Enregistrement réussi
    saved: Enregistré
    scale_factor: Facteur d'échelle
    search: Rechercher
    search_by: Rechercher par nom, email ou niveau d'accès
    search_by_name: Rechercher par nom
    search_companies: Rechercher des entreprises
    search_counties: Rechercher des comtés
    search_powerplants: Rechercher des centrales électriques
    seconds: Secondes
    select: Sélectionner
    select_asset_type: Sélectionnez le type d'actif
    select_columns: Sélectionner les colonnes
    selection: Sélection
    send: Envoyer
    sensors: Capteurs Nest
    show: Voir
    show_edit: Voir/Éditer
    show_less: Afficher moins
    show_more: Afficher %{count} de plus
    show_subsidiaries: Voir les filiales
    slowest: Plus lentes
    snow: Neige
    solar: Solaire
    solar_backend_configuration: Configuration du backend solaire
    sort_by: Filtrer par
    spot_price: Prix spot
    start_date: Date de début
    statistics: Statistique
    status: Statut
    summary: Résumé
    supplier_contact_email: Email de contact du fournisseur
    supplier_contact_phone: Téléphone de contact du fournisseur
    supplier_name: Nom du fournisseur
    temperature: Température
    tertiary: Tertiaire
    timestamp: Horodatage
    title: Titre
    to: à
    today: Aujourd'hui
    token: Token
    top: Top
    total: Total
    total_production: Production totale
    trend_last_24_hours: Tendance 24h
    treshold_mw: Seuil MW
    unexpected_error: Erreur inattendue
    unknown: Inconnu
    unknown_error: Une erreur est survenue
    unlock_account: Déverrouiller compte
    unsaved_changes: Vous avez des modifications non enregistrées.
    update: Mise à jour
    updated: Mis à jour
    user_access_level: Niveau d'accès
    valid_contract: Contrat valide
    validations:
      non_negative: Non nul
      required: Requis
    view_details: Voir les détails
    volume: Production
    volume_percent: Pourcentage en volume
    weekly: Hebdomadaire
    welcome: Bienvenue
    wind: Éolien
    wind_backend_configuration: Configuration du backend éolien
    wind_speed: Vitesse du vent
    wrong_email_or_password: Mauvaise adresse e-mail ou mot de passe
    year: Année
    yearly: Annuel
    'yes': Oui
